// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2025 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import GetSchedulerByRoomsRequestModel from '../../model/get-scheduler-by-rooms-request-model';
import GetSchedulerByRoomsRequestDTO from '../dto/get-scheduler-by-rooms-request-dto';
import dtoSchema from '../schemas/get-scheduler-by-rooms-request-schema';

export default abstract class GetSchedulerByRoomsRequestModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<GetSchedulerByRoomsRequestDTO>) {
    super();
    if (data) {
      this.startTime = data.startTime;
      this.endTime = data.endTime;
      this.selectedResourceTypes = data.selectedResourceTypes;
    }
  }
  /**
  * @type {date-time}
  */
  startTime?: string;
  /**
  * @type {date-time}
  */
  endTime?: string;
  /**
  */
  selectedResourceTypes?: number[];

  static toModel(dto: DeepPartial<GetSchedulerByRoomsRequestDTO>): GetSchedulerByRoomsRequestModel;
  static toModel(dto: DeepPartial<GetSchedulerByRoomsRequestDTO> | undefined | null): GetSchedulerByRoomsRequestModel | undefined;
  static toModel(dto: DeepPartial<GetSchedulerByRoomsRequestDTO> | undefined | null): GetSchedulerByRoomsRequestModel | undefined {
    return dto ? new GetSchedulerByRoomsRequestModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<GetSchedulerByRoomsRequestModel> | GetSchedulerByRoomsRequestModel): GetSchedulerByRoomsRequestDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      startTime: unwrapped.startTime,
      endTime: unwrapped.endTime,
      selectedResourceTypes: unwrapped.selectedResourceTypes,
    } as GetSchedulerByRoomsRequestDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for GetSchedulerByRoomsRequestModel, can not map to GetSchedulerByRoomsRequestDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
